import { render, staticRenderFns } from "./DangKyDDATListSuccess.vue?vue&type=template&id=0ae3bee6&"
import script from "./DangKyDDATListSuccess.vue?vue&type=script&lang=js&"
export * from "./DangKyDDATListSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports